export const apiAmountToCurrencyString = (integer: number): string =>
  (integer / 100).toFixed(2);
